import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useRedirectIfNoContent = ({
  hasContent,
  redirectTo,
  skip = false,
}: {
  hasContent: boolean | undefined;
  redirectTo: string;
  skip?: boolean;
}): null => {
  const router = useRouter();

  useEffect(() => {
    // Don't redirect if:
    // - skip is true (data still loading or other condition)
    // - hasContent is undefined/null (data not loaded yet)
    // - hasContent is true (content exists)
    if (
      skip ||
      hasContent === undefined ||
      hasContent === null ||
      hasContent === true
    ) {
      return;
    }

    // Only redirect when we've confirmed there's no content
    if (hasContent === false) {
      router.replace(redirectTo);
    }
  }, [hasContent, redirectTo, skip, router]);

  return null;
};
